import React from "react";
import { type OnChangeFn, type SortingState } from "@tanstack/react-table";

import { type setSortType } from "../../types";

export const useTableSorting = <S extends string = string>(
  setSort?: (sort: setSortType<S>) => void,
  initialSorting?: SortingState,
) => {
  const [sorting, setSorting] = React.useState<SortingState>(
    initialSorting || [],
  );

  const handleSortingChange = React.useCallback<OnChangeFn<SortingState>>(
    (updaterOrValue) => {
      const newSorting =
        typeof updaterOrValue === "function"
          ? updaterOrValue(sorting)
          : updaterOrValue;
      setSorting(newSorting);

      if (!setSort) return;

      if (newSorting.length > 0) {
        const convertSortedType = (desc: boolean, id: S): setSortType<S> =>
          desc
            ? { by: id, type: "DESC" as const }
            : { by: id, type: "ASC" as const };
        const sortedColumnTransform = convertSortedType(
          newSorting[0].desc,
          newSorting[0].id as S,
        );

        setSort(sortedColumnTransform);
      } else {
        setSort({ by: "" as S, type: false });
      }
    },
    [setSort, sorting],
  );

  return {
    sorting,
    handleSortingChange,
  };
};
